module.exports = {
  MAPS_API_BASE_URL: 'api/v1/map'
};



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/windshaft/config.js
// module id = 1058
// module chunks = 6